<template>
  <sub-page title="求职创业补贴个人申报">
    <div class="subsidy-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">戴义杰</div>
          <div class="user-id">3411**********5619</div>
        </div>
      </div>

      <!-- 个人基本信息 -->
      <div class="section-title">个人基本信息</div>
      <div class="form-body" @click="onFormClick">
        <div class="form-item">
          <span class="form-label required">联系电话</span>
          <input v-model="form.phone" class="form-input" placeholder="请输入联系电话" />
        </div>
        <div class="form-item">
          <span class="form-label required">性别</span>
          <div class="picker" @click="selectField('性别')">
            <span :class="['picker-value', { placeholder: !form.gender }]">{{ form.gender || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">民族</span>
          <div class="picker" @click="selectField('民族')">
            <span :class="['picker-value', { placeholder: !form.nation }]">{{ form.nation || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label">补贴类别</span>
          <span class="form-value">求职创业补贴</span>
        </div>
        <div class="form-item">
          <span class="form-label required">学历</span>
          <div class="picker" @click="selectField('学历')">
            <span :class="['picker-value', { placeholder: !form.education }]">{{ form.education || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">毕业学校</span>
          <input v-model="form.school" class="form-input" placeholder="请输入学校名称或学校编号来搜索" />
        </div>
        <div class="form-item">
          <span class="form-label required">毕业年度</span>
          <div class="picker" @click="selectField('毕业年度')">
            <span :class="['picker-value', { placeholder: !form.gradYear }]">{{ form.gradYear || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">毕业生类型</span>
          <div class="picker" @click="selectField('毕业生类型')">
            <span :class="['picker-value', { placeholder: !form.gradType }]">{{ form.gradType || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label">核准标志</span>
          <span class="form-value">未核准</span>
        </div>
        <div class="form-item">
          <span class="form-label required">学号</span>
          <input v-model="form.studentNo" class="form-input" placeholder="请输入学号" />
        </div>
        <div class="form-item">
          <span class="form-label required">所在院系</span>
          <input v-model="form.department" class="form-input" placeholder="请输入所在院系,格式为学院名+系名" />
        </div>
        <div class="form-item">
          <span class="form-label required">专业</span>
          <input v-model="form.major" class="form-input" placeholder="请输入专业" />
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="footer-btns">
        <button class="upload-btn" @click="uploadMaterial">上传材料</button>
        <button class="submit-btn" @click="handleSubmit">提交</button>
      </div>

      <!-- 字段选择 -->
      <field-sheet
        :show="sheet.show"
        :title="sheet.title"
        :options="sheet.options"
        :value="sheet.value"
        @select="onSheetSelect"
        @close="sheet.show = false"
      />
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'SubsidyApply',
  components: { SubPage, FieldSheet },
  data() {
    return {
      form: {
        phone: '',
        gender: '',
        nation: '',
        education: '',
        school: '',
        gradYear: '',
        gradType: '',
        studentNo: '',
        department: '',
        major: ''
      },
      fieldOptions: {
        '性别': { key: 'gender', options: ['男', '女'] },
        '民族': { key: 'nation', options: ['汉族', '回族', '满族', '其他'] },
        '学历': { key: 'education', options: ['博士研究生', '硕士研究生', '大学本科', '大学专科', '中职（中专/技校/职高）'] },
        '毕业年度': { key: 'gradYear', options: ['2020', '2021', '2022', '2023', '2024', '2025', '2026'] },
        '毕业生类型': { key: 'gradType', options: ['低保家庭毕业生', '残疾毕业生', '获得国家助学贷款毕业生', '脱贫家庭毕业生', '特困人员中的毕业生', '残疾孤儿毕业生'] }
      },
      sheet: { show: false, title: '', options: [], value: '', key: '' }
    }
  },
  methods: {
    selectField(name) {
      const conf = this.fieldOptions[name]
      if (!conf) return
      this.sheet = { show: true, title: '请选择' + name, options: conf.options, value: this.form[conf.key], key: conf.key }
    },
    onFormClick(e) {
      const item = e.target.closest('.form-item')
      if (!item) return
      const label = item.querySelector('.form-label')
      if (label) this.selectField(label.textContent.replace(/^\*/, ''))
    },
    onSheetSelect(val) {
      this.form[this.sheet.key] = val
      this.sheet.show = false
    },
    uploadMaterial() {
      this.$alert('请上传身份证、毕业生就业推荐表、困难情形证明等材料（演示环境）')
    },
    handleSubmit() {
      const f = this.form
      const checks = [
        [!f.phone, '请输入联系电话'],
        [!f.gender, '请选择性别'],
        [!f.nation, '请选择民族'],
        [!f.education, '请选择学历'],
        [!f.school, '请输入毕业学校'],
        [!f.gradYear, '请选择毕业年度'],
        [!f.gradType, '请选择毕业生类型'],
        [!f.studentNo, '请输入学号'],
        [!f.department, '请输入所在院系'],
        [!f.major, '请输入专业']
      ]
      for (const [cond, msg] of checks) {
        if (cond) { this.$alert(msg); return }
      }
      if (!/^1[3-9]\d{9}$/.test(f.phone)) {
        this.$alert('请输入正确的联系电话')
        return
      }
      this.$alert('求职创业补贴申报已提交，请等待学校及人社部门审核')
    }
  }
}
</script>

<style scoped>
.subsidy-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.section-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #323233;
  padding: calc(24 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.form-body {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(30 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(180 * var(--w));
  flex-shrink: 0;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-input {
  flex: 1;
  height: calc(110 * var(--w));
  border: none;
  outline: none;
  font-size: calc(30 * var(--w));
  color: #323233;
  background: transparent;
}
.form-input::placeholder {
  color: #969799;
  font-size: calc(26 * var(--w));
}
.form-value {
  flex: 1;
  font-size: calc(30 * var(--w));
  color: #323233;
}
.picker {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.picker-value {
  font-size: calc(30 * var(--w));
  color: #323233;
}
.picker-value.placeholder {
  color: #969799;
}
.picker-arrow {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.footer-btns {
  display: flex;
  gap: calc(24 * var(--w));
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.upload-btn,
.submit-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/SubsidyApply.vue